import { Box, Hidden } from "@mui/material";
import React from "react";
import Explore from "./Explore";
import MobileExplore from "./MobileExplore";

const MainExplore = () => {
  return (
    <Box>
      <Hidden mdDown>
        <Explore />
      </Hidden>

      <Hidden mdUp>
        <MobileExplore />
      </Hidden>
    </Box>
  );
};

export default MainExplore;
